import { render } from "./Nombre_resultat_par_page.vue?vue&type=template&id=8095864e"
import script from "./Nombre_resultat_par_page.vue?vue&type=script&lang=js"
export * from "./Nombre_resultat_par_page.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Sebastien.Ducharme/condamnation-datepicker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__